
<template>
	<div class="search-wrap">
		<aside class="search-btn">
			<ButtonGroup>
				<Button
					v-for="(item,index) in btnsearch"
					size="large"
					:key="index"
					:type="formData.status===item.key?'primary':'default'"
					@click="handleBtn('status',item.key)"
				>{{item.label}}</Button>
			</ButtonGroup>
		</aside>
		<article class="search-main clearfix">
			<div class="pull-left">
				<Button type="primary" @click="handleModal('add')" icon="md-add">{{$t('erp.product.new_add',{defaultValue:'添加'})}}</Button>
				<Button type="success" @click="handleModal('upload')">{{$t('global.common.import',{defaultValue:'导入'})}}</Button>
				<Button type="info" @click="handleModal('export')">{{$t('global.common.export',{defaultValue:'导出'})}}</Button>
				<!-- <Dropdown trigger="click">
                    <Button>
                        更多操作<Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem @click.native="handleModal('delete')">批量删除</DropdownItem>
                    </DropdownMenu>
				</Dropdown>-->
			</div>

			<div class="pull-right">
				<Form :label-width="80" inline>
					<FormItem :label="$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'})">
						<Select
							v-model="formData.stockTemplateId"
							filterable
							clearable
							@on-query-change="getTemplatelist"
						>
							<Option v-for="item in templatelist" :value="item.id" :key="item.id">{{ item.templateName }}</Option>
						</Select>
					</FormItem>
					<FormItem label="ERP SKU">
						<Input clearable v-model.trim="formData.erpSku" placeholder="ERPSKU"/>
					</FormItem>
					<FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
						<Select clearable v-model="formData.lineId" filterable>
							<Option value>All</Option>
							<Option value="-1">Others</Option>
							<Option v-for="(item,index) in getNewDifferentAllProductList" :value="item.value" :key="index">{{ item.label }}</Option>
						</Select>
					</FormItem>
					<FormItem :label-width="1">
						<Button type="primary" @click="update" icon="ios-search">{{$t('global.common.search',{defaultValue:'搜索'})}}</Button>
						<Button @click="reset" icon="refresh">{{$t('erp.disturibution.reset_order',{defaultValue:'重置'})}}</Button>
						<Button type="text" @click="isOpen=!isOpen">{{$t('global.common.searchs',{defaultValue:'更多搜索'})}}
							<Icon type="ios-arrow-down" class="margin-left-5"></Icon>
						</Button>
					</FormItem>
				</Form>
			</div>
		</article>
		<transition name="slide-both">
			<Form class="search-other" :label-width="80" inline v-show="isOpen">
				<FormItem :label="$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'})">
					<Select v-model="formData['ruleId']" filterable clearable @on-query-change="getVsGroups">
						<Option v-for="item in vsgroups" :value="item.id" :key="item.id">{{ item.name }}</Option>
					</Select>
				</FormItem>
				<FormItem :label="$t('erp.virtualstore.description',{defaultValue:'模板描述'})">
					<Input clearable v-model.trim="formData.description"/>
				</FormItem>
				<FormItem :label="$t('erp.virtualstore.tempstatus',{defaultValue:'模板状态'})">
					<Select clearable v-model="formData.status">
						<Option v-for="(item,index) in btnsearch" :value="item.value" :key="index">{{ item.label }}</Option>
					</Select>
				</FormItem>
				<FormItem :label="$t('fbb.adjustment.created_name',{defaultValue:'创建人'})">
					<!-- <Input clearable v-model="formData.createdBy "/> -->
					<Select v-model="formData.createdBy " filterable clearable @on-query-change="getCreatedName">
						<Option v-for="item in namelist" :value="item.id" :key="item.id">{{ item.name }}</Option>
					</Select>
				</FormItem>
			</Form>
		</transition>
	</div>
</template>

<script>
import { mapState,mapGetters} from 'vuex';
import {  HttpSaTemplateList } from '@/service/boss/allot';
import { HttpPersonInfoList,HttpVsGroups } from '@/service/boss/dictionary';

export default {
	data() {
		return {
			isOpen: false,
			templatelist: [],
			namelist: [],
			vsgroups: [],
			

			formData: {
				erpSku: "",
				// templateName: '',
				description: '',
				'ruleId': '',
				lineId: '',
				status: 1,
				createdBy: '',
				stockTemplateId: '',
			},
		};
	},
	mounted() {
		this.update();
		this.getVsGroups();
		this.getTemplatelist();
		this.getCreatedName();
	},
	computed: {
		...mapGetters('diction',['getNewDifferentAllProductList']),
        btnsearch(){
            return [{
				value: 'ACTIVE',
				key: 1,
				label: this.$t('global.common.effective',{defaultValue:'有效'})
			}, {
				value: 'INACTIVE',
				key: 0,
				label: this.$t('global.common.failure',{defaultValue:'失效'})
			}, {
				value: '',
				key: '',
				label: this.$t('global.common.all',{defaultValue:'全部'})
			},]
        },
	},
	methods: {
		async getVsGroups(query = "") {
			let Group_status;
			if (this.formData.status === 1) {
				Group_status = 'ACTIVATE'
			} else if (this.formData.status === 0) {
				Group_status = 'INACTIVATE'
			} else {
				Group_status = ''
			}
			HttpVsGroups({
				page: 1,
				rows: 50,
				sidx: 'id',
				sord: 'desc',
				search: {
					'EQ_stockVirtualGroupEntity.status': Group_status,
					CN_name: query
				}
			}).then(res => {
				this.vsgroups = res.data.content;
			});
		},
		handleModal(type, id) {
			this.$parent.handleOperates(id, type);
		},
		handleBtn(key, val) {
			this.$set(this.formData, key, val);
			this.update();
		},
		update() {
			this.$emit('on-update', {
				erpSku: this.formData.erpSku,
				// templateName:this.formData.templateName,
				lineId: this.formData.lineId,
				description: this.formData.description,
				ruleId: this.formData.ruleId,
				status: this.formData.status,
				createdBy: this.formData.createdBy,
				stockTemplateId: this.formData.stockTemplateId,
				page: 1			});
		},
		reset() {

			this.formData = {
				erpSku: "",
				lineId:"",
				// templateName: '',
				description: '',
				"ruleId": '',
				status: null,
				createdBy: '',
				stockTemplateId: '',
			};
			this.$emit('on-update', {
				erpSku: this.formData.erpSku,
				lineId: this.formData.lineId,
				description: this.formData.description,
				ruleId: this.formData.ruleId,
				status: this.formData.status,
				createdBy: this.formData.createdBy,
				stockTemplateId: this.formData.stockTemplateId,
				page: 1
			});
		},
		async getTemplatelist(query = "") {
			HttpSaTemplateList({
				page: 1,
				rows: 50,
				sidx: 'id',
				sord: 'desc',
				search: {
					stockTemplateId: query,
					status: this.formData.status,

				}
			}).then(res => {
				this.templatelist = res.data.content;
			});
		},
		async getCreatedName(query = "") {
			HttpPersonInfoList({
				page: 1,
				rows: 50,
				sidx: 'id',
				sord: 'desc',
				search: {
					CN_name: query
				}
			}).then(res => {
				this.namelist = (res.data.content || []).map((item) => {
					return { name: item.name, id: item.id }
				});
			});
		},
	},
};
</script>
